<template>
  <div class="pop_conditions" style="display:block;">
    <div class="popup_close close_cond close-animate">
      <a href="javascript:void(0);" @click.prevent="$modal.hide('conditions')">
        <close/>
      </a>
    </div>
    <div class="pop_frame">
      <h2 class="title25">תנאים נוספים</h2>
      <div class="text">
        <ul class="terms">
          <li>שיערוך עלות ההזמנה לא כולל דמי משלוח בסך {{cost}} ₪</li>
          <li>המחירים מעודכנים לתאריך {{nowDate}}</li>
          <li>מינימום הזמנה באתר {{minimumOrder}} ₪</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import Close from "../../assets/img/close.svg";
  export default {
    data() {
      return {
        cost: wpData.shipment_cost,
        minimumOrder: wpData.minimum_order.amount
      }
    },
    computed: {
       nowDate(){
        let todayDate = new Date();
        var mounth = (todayDate.getMonth() + 1);
        var day = (todayDate.getDate() );
        var year = (todayDate.getFullYear() );
        return `${day}/${mounth}/${year}`;
      },
    },
    components: {
      Close
    }
  };
</script>

<style scoped>
.terms {
  text-align: right;
  padding: 0 2em;
}
</style>